import { Icon } from 'components/common'

const Socials = ({ socials }) => {
    return (socials?.linkedin || socials?.twitter || socials?.facebook || socials?.instagram) ? (
        <div className='socials flexBox'>
            {socials.linkedin && (
                <a href={socials.linkedin} className='ln' target='_blank'>
                    <Icon className='op-linkedin' />
                </a>
            )}
            {socials.twitter && (
                <a href={socials.twitter} className='tw' target='_blank'>
                    <Icon className='op-twitter' />
                </a>
            )}
            {socials.instagram && (
                <a href={socials.instagram} className='insta' target='_blank'>
                    <Icon className='op-instagram' />
                </a>
            )}
            {socials.facebook && (
                <a href={socials.facebook} className='fb' target='_blank'>
                    <Icon className='op-facebook' />
                </a>
            )}
        </div>
    ) : null
}

export default Socials